export const caseIDSelector = state =>
  state.getIn(['app', 'litigation', 'case', 'data', 'caseID']);
export const caseInfoSelector = state =>
  state.getIn(['app', 'litigation', 'case', 'data']).toJS();
export const immutableCaseInfoSelector = state =>
  state.getIn(['app', 'litigation', 'case', 'data']);
export const caseStateSelector = state =>
  state.getIn(['app', 'litigation', 'case']).toJS().state;
export const activeCaseSelector = state =>
  state.getIn(['app', 'litigation', 'case']).toJS().activeCase;
export const caseSummarySelector = state =>
  state.getIn(['app', 'litigation', 'case', 'summary']).toJS();
export const rollCorrsSelector = state =>
  state.getIn(['app', 'litigation', 'case', 'rollCorrs']).toJS();
export const backCaseSelector = state =>
  state.getIn(['app', 'litigation', 'case', 'backCase']).toJS();
